import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import { MaterialRequestListAction } from './material-request-list.actions';
import {
  MaterialRequestListContent,
  MaterialRequestListSearchCriteria
} from '../../model/material-request-list.model';

export interface MaterialRequestListState extends EntityState<MaterialRequestListContent> {
  isLoading: boolean;
  selected: MaterialRequestListContent[];
  criteriaObject: MaterialRequestListSearchCriteria;
  totalElements: number;
  totalPages: number;
  auditLogs: any;
}

export const adapter: EntityAdapter<MaterialRequestListContent> = createEntityAdapter<MaterialRequestListContent>({
  selectId: (model: MaterialRequestListContent) => model.docNo
});

export const initialState: MaterialRequestListState = adapter.getInitialState({
  isLoading: false,
  selected: [],
  criteriaObject: {
    page: 0,
    size: 20
  },
  totalElements: null,
  totalPages: 20,
  auditLogs: [],
  viewResponse: null
});

export const materialRequestListReducer = createReducer<MaterialRequestListState>(
  initialState,
  on(MaterialRequestListAction.responseList, (state, action): MaterialRequestListState => {
    return {
      ...state,
      selected: action.data.content,
      totalElements: action.data.totalElements,
      isLoading: false,
      criteriaObject: {
        ...state.criteriaObject,
        page: action.data.page,
        size: action.data.size
      }
    };
  })
);
